import { Upload } from "antd";
import { useState } from "react";
import { toast } from "react-toastify";
import { IconUpload } from "../../../assets/icons";
import ButtonComponent from "../../../components/ButtonComponent/ButtonComponent";
import ImportProductsSampleFile from "../../../assets/excel/mau-tai-san-pham.xlsm";
import ExcelLogo from "../../../assets/images/microsoft-excel-icon.webp";

const ImportProductsForm = ({ onImport, loading }) => {
  const [file, setFile] = useState(null);
  const handleUpload = (info) => {
    setFile(info.file);
  };

  const handleSubmit = () => {
    if (!file) {
      toast.error("Vui lòng chọn một file để import!");
      return;
    }

    const formData = new FormData();
    formData.append("file", file.originFileObj || file);

    onImport?.(formData);
  };

  return (
    <div className="flex flex-col gap-4">
      {/* Upload file */}
      <Upload
        accept=".csv,.xlsx,.xls,.xlsm"
        beforeUpload={() => false}
        onChange={handleUpload}
      >
        <ButtonComponent
          label={"Chọn file CSV/Excel"}
          prefix={<IconUpload className="w-4 h-4 fill-black" />}
          className={
            "!bg-gray-200 px-4 py-2 rounded-md hover:bg-gray-300 !text-black"
          }
        />
      </Upload>

      <div className="w-full px-4 py-2 bg-[#F0F0F0] rounded-md flex justify-between items-center border-2 border-dashed">
        <div className="flex flex-row items-center gap-2">
          <img src={ExcelLogo} alt="ExcelLogo" className="w-4 h-4" />
          <span>File mẫu tải sản phẩm</span>
        </div>
        <a
          href={ImportProductsSampleFile}
          download="mau-tai-san-pham.xlsm"
          className="text-primaryColor underline hover:text-primaryColor/80"
        >
          Tải xuống
        </a>
      </div>

      {/* Submit button */}
      <div className="">
        <button
          type="button"
          className={`px-4 py-2 rounded-md ${
            loading
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-primaryColor text-white hover:bg-primaryColor/90"
          } transition`}
          disabled={loading}
          onClick={handleSubmit}
        >
          {loading ? "Đang xử lý..." : "Tải lên"}
        </button>
      </div>
    </div>
  );
};

export default ImportProductsForm;
